import * as React from "react";
import { Textarea } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";
import "./fluent-overide.scss";

export const FluentInputArea = ({
  label,
  disabled,
  validationMessage,
  placeholder,
  required,
  size,
  value,
  defaultValue,
  onChange,
  onBlur,
  name,
  id,
  componentStyle,
  noKey = false
}) => {
  return (
    <FluentField
      size={size}
      label={label}
      validationMessage={validationMessage}
      required={required}
    >
      <Textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value !== undefined ? value : undefined}
        defaultValue={value === undefined ? defaultValue : undefined}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={`fluentInput ${componentStyle || ""}`}
        resize="vertical"
        key={noKey ? null : value ?? defaultValue}
      />
    </FluentField>
  );
};

FluentInputArea.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  componentStyle: PropTypes.string,
  noKey: PropTypes.bool,
};